import React from 'react';
import { Button } from '../ui/button';

const AdminHeader = ({ onLogout }) => {
  return (
    <header className="bg-[#1a2f23] text-white py-4 px-6">
      <div className="container mx-auto flex justify-between items-center">
        <div>
          <h1 className="text-xl">Fatimia Admin Dashboard</h1>
          <p className="text-sm text-[#c5a572]">Manage your community website</p>
        </div>
        <Button 
          onClick={onLogout} 
          variant="outline" 
          className="border-[#c5a572] text-[#c5a572] hover:bg-[#c5a572] hover:text-[#1a2f23]"
        >
          Logout
        </Button>
      </div>
    </header>
  );
};

export default AdminHeader;
